import { ISearchRequest } from '../../shared/interfaces'
import { AppNavigationState, AppNavigationActionTypes, UPDATE_APP_NAVIGATION_STATE, SET_PROTOCOL, UNSET_PROTOCOL, SET_SEARCH_TABLE_STATE, UNSET_SEARCH_TABLE_STATE, SET_FASCICOLO, UNSET_FASCICOLO, SET_WORKSPACE_TABLE_STATE, UNSET_WORKSPACE_TABLE_STATE, SET_PREVIOUS_LOCATION_PATHNAME, UNSET_PREVIOUS_LOCATION_PATHNAME } from './types'

const initialState: AppNavigationState = {
    protocol: {
        fields: [],
        attachments: []
    },
    searchTableState: undefined,
    workspaceTableState: undefined,
    previousLocationPathName: undefined

}




export function appNavigationReducer(state = initialState, action: AppNavigationActionTypes): AppNavigationState {
    switch (action.type) {
        case UPDATE_APP_NAVIGATION_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        case SET_PROTOCOL: {
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    ...action.protocol
                }
            }
        }
        case UNSET_PROTOCOL: {
            return {
                ...state,
                protocol: {
                    fields: [],
                    attachments: []
                }
            }
        }

        case SET_FASCICOLO: {
            return {
                ...state,
                fascicolo: {
                    ...state.fascicolo,
                    ...action.fascicolo
                }
            }
        }
        case UNSET_FASCICOLO: {
            return {
                ...state,
                fascicolo: {

                }
            }
        }

        case SET_SEARCH_TABLE_STATE: {
            return {
                ...state,
                searchTableState: {
                    ...state.searchTableState,
                    ...action.protocolsTableState!
                }
            }
        }
        case UNSET_SEARCH_TABLE_STATE: {
            return {
                ...state,
                searchTableState: undefined
            }
        }

        case SET_WORKSPACE_TABLE_STATE: {
            return {
                ...state,
                workspaceTableState: {
                    ...state.workspaceTableState,
                    ...action.workspaceTableState!
                }
            }
        }
        case UNSET_WORKSPACE_TABLE_STATE: {
            return {
                ...state,
                workspaceTableState: undefined
            }
        }

        case SET_PREVIOUS_LOCATION_PATHNAME: {
            return {
                ...state,
                previousLocationPathName: action.previousLocationPathName
            }
        }
        case UNSET_PREVIOUS_LOCATION_PATHNAME: {
            return {
                ...state,
                previousLocationPathName: undefined
            }
        }

        default:
            return state
    }
}